import React, { useState, useEffect } from "react";
import "./SuggestedPrice.css";
//components
import Button from "../../../../components/Button/Button";
import Table from "../../../../components/Table/Table";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import Modal from "../../../../components/Modal/Modal";
//services
import { supportService } from "../../../../services/Support";
//utils
import { formatDate } from "../../../../utils/utils";
import { useNavigate } from "react-router-dom";
//assets
import trashActive from "../../../../assets/tokens/trashActive.png";
import editIcon from "../../../../assets/editIcon.png";
//service
import { serviceSuggestedService } from "../../../../services/serviceSuggested";

const SuggestedPrice = () => {
  const navigate = useNavigate();
  const [columns, setColumns] = useState([]);
  const [serviceSuggestedData, setServiceSuggestedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState({ text: "", highlight: "" });
  const [modalMessage, setModalMessage] = useState("");
  const [error, setError] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    fetchColumns();
    fetchServiceSuggestedData(currentPage);
  }, [currentPage, selectedStatus, selectedDate]);

  const fetchServiceSuggestedData = async (page = 1) => {
    try {
      const params = {
        page,
        items_per_page: 10,
        limit: 10,
        ...(searchTerm && { query: searchTerm }),
      };
      const response = await serviceSuggestedService.getList(params);

      const payload = response?.data ?? response;
      const list = payload?.data ?? payload?.results ?? payload ?? [];
      const total =
        payload?.total ??
        payload?.count ??
        (Array.isArray(list) ? list.length : 0);

      const mapped = (Array.isArray(list) ? list : []).map((item) => ({
        id: item.id,
        name: item.name ?? item.service?.name ?? item.service_name ?? "",
        price: item.price ?? item.base_rate ?? item.rate ?? "",
        is_active: item.is_active,
      }));

      setServiceSuggestedData(mapped.filter((item) => item.is_active === 1));
      setTotalItems(total);
    } catch (error) {
      console.error("Error fetching service suggested data:", error);
    }
  };

  const fetchColumns = () => {
    const columnsData = [
      { header: "Name of service", field: "name" },
      { header: "Suggested price", field: "price" },
      {
        header: "",
        render: (row) => (
          <Tooltip text="Edit suggested price">
            <button className="view-btn" onClick={() => handleEdit(row)}>
              <img src={editIcon} alt="View" />
            </button>
          </Tooltip>
        ),
      },
      {
        header: "",
        render: (row) => (
          <Tooltip text="Delete suggested price">
            <button className="view-btn" onClick={() => handleDelete(row)}>
              <img src={trashActive} alt="View" />
            </button>
          </Tooltip>
        ),
      },
    ];

    setColumns(columnsData);
  };

  const handleEdit = (row) => {
    console.log("Edit suggested price:", row);
    navigate(`/configurations/suggested-price/edit/${row.id}`, {
      state: {
        edtiData: row,
        action: "edit",
      },
    });
  };

  const handleDelete = (row) => {
    setSelectedId(row.id);
    setIsDeleted(true);
    setModalTitle({ text: "Delete Suggested Price", highlight: row.name });
    setModalMessage(
      "Are you sure you want to delete this suggested price? This action cannot be undone.",
    );
    setError(false);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setIsDeleted(false);
    fetchServiceSuggestedData();
  };

  const handleConfirmDelete = async () => {
    try {
      console.log("Deleting suggested price with ID:", selectedId);
      const response = await serviceSuggestedService.delete(selectedId);
      if (response.status === "success") {
        setModalTitle({
          text: "Suggested price deleted",
          highlight: "successfully",
        });
        setModalMessage("The suggested price has been deleted successfully.");
        setError(false);
        setIsModalOpen(true);
      } else {
        setModalTitle({ text: "Error deleting", highlight: "suggested price" });
        setModalMessage(
          response.message ||
            "An error occurred while deleting the suggested price.",
        );
        setError(true);
        setIsModalOpen(true);
      }
    } catch (error) {
      setModalTitle({ text: "Error deleting", highlight: "suggested price" });
      setModalMessage(
        error.message ||
          "An error occurred while deleting the suggested price.",
      );
      setError(true);
      setIsModalOpen(true);
    } finally {
      handleModalClose();
    }
  };

  return (
    <div className="suggested-price-page">
      <div className="suggested-price-container">
        <div className="actions-bar">
          <div className="action-buttons">
            <Button
              variant="primary"
              children="Add suggested price"
              onClick={() => {
                navigate("/configurations/suggested-price/new", {
                  state: {
                    edtiData: null,
                    action: "add",
                  },
                });
              }}
              borderRadius={10}
            />
          </div>
        </div>
        <div className="table-container">
          <Table
            columns={columns}
            data={serviceSuggestedData}
            columnsShare={2}
            currentPage={currentPage}
            itemsPerPage={10}
            totalItems={totalItems}
            onPageChange={(page) => {
              setCurrentPage(page);
              fetchServiceSuggestedData(page);
            }}
          />
          <Modal
            isOpen={isModalOpen}
            showCancelButton={isDeleted}
            onClose={handleModalClose}
            title={modalTitle}
            message={modalMessage}
            error={error}
            onConfirm={handleConfirmDelete}
            confirmText="Delete service"
          />
        </div>
      </div>
    </div>
  );
};

export default SuggestedPrice;
